<template>
  <div class="project">
    <div class="project-header">
      <div class="project-name">
        {{ investment.project.name }}
      </div>
      <div class="project-location">
        {{ investment.project.location }}
      </div>
    </div>
    <div class="investment-info">
      <div class="project-stats">
        <div class="stat">
          <div class="stat-name">Inversión</div>
          <div class="stat-value">{{ formatMoney(investment.investment) }}</div>
        </div>
        <div class="stat">
          <div class="stat-name">Inicio de los pagos</div>
          <div class="stat-value">{{ investment.project.paymentsStartDate ? moment(investment.project.paymentsStartDate).format('MMM YYYY') : 'TBA' }}</div>
        </div>
        <div class="stat">
          <div class="stat-name">Pagos realizados</div>
          <div class="stat-value">{{ investment.payments.length }}</div>
        </div>
        <div class="stat">
          <div class="stat-name">Pagos restantes</div>
          <div class="stat-value">{{ investment.project.totalMonthPayments - investment.payments.length }}</div>
        </div>
        <div class="stat">
          <div class="stat-name">Total recibido</div>
          <div class="stat-value">{{ formatMoney(totalPayments) }}</div>
        </div>
        <div class="project-link-m" @click="downloadContract(investment.investment, investment.project.id)">
          Descargar contrato
        </div>
      </div>
      <div class="project-info">
        <div class="project-image" :style="{ backgroundImage: `url(${investment.project.mainImageUrl})` }"></div>
        <div class="project-link" @click="$router.push(`/project/${investment.project.id}`)">
          Ver proyecto
        </div>
        <div class="project-link" @click="downloadContract(investment.investment, investment.project.id)">
          Descargar contrato
        </div>
      </div>
    </div>
    <div class="project-details">
      <div class="details-button" v-show="!open" @click="open = true">Ver detalles</div>
      <div class="details-button" v-show="open" @click="open = false">Ocultar</div>
      <div class="project-graph" v-show="open">
        <canvas :id="`myChart-${investment.id}`" width="300" height="60" style="min-height:200px"></canvas>
      </div>
      <div class="project-payments" v-show="open">
        <div class="payments-header">Pagos</div>
        <div class="p-pay" v-for="(payment, index) in investment.payments" :key="index">
          <div style="font-weight: 500;">{{ moment(investment.project.paymentsStartDate).add(index, 'M').format('MMM YYYY') }}</div>
          <div>{{ formatMoney(payment.payment) }}</div>
        </div>
        <div class="empty-state" v-if="investment.payments.length === 0">
          Aun no haz recibido ningún pago de este proyecto
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import download from 'downloadjs';
import formatMixin from '@/mixins/formatMixin';

export default {
  data() {
    return {
      moment,
      open: false,
    };
  },
  props: {
    investment: Object,
  },
  mixins: [formatMixin],
  computed: {
    totalPayments() {
      let total = 0;
      for (let i = 0; i < this.investment.payments.length; i += 1) {
        const element = this.investment.payments[i];
        total += parseInt(element.payment, 10);
      }
      return total;
    },
  },
  methods: {
    stylizeNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    async downloadContract(investment, projectId) {
      const response = await axios.post(`${process.env.VUE_APP_SERVER_URL}/pdf`, { investment: parseInt(investment, 10), projectId: parseInt(projectId, 10) }, { responseType: 'blob' });
      download(response.data, 'Contrato.pdf', 'application/pdf');
    },
  },
  mounted() {
    const project = this.investment;

    const ctx = document.getElementById(`myChart-${this.investment.id}`).getContext('2d');
    const fixedPayments = [];
    const labels = [];

    for (let i = 0; i < project.payments.length; i += 1) {
      const element = project.payments[i];
      fixedPayments.push(element.payment / 100);
      labels.push(this.moment(project.project.paymentsStartDate).add(i, 'M').format('MMM YYYY'));
    }

    const gradient = ctx.createLinearGradient(0, 0, 200, 0);
    gradient.addColorStop(0, 'rgba(0,160,225,1)');
    gradient.addColorStop(1, 'rgba(22,70,212,1)');

    // eslint-disable-next-line
      const myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [{
          label: 'Pago',
          borderColor: gradient,
          data: fixedPayments,
          fill: false,
        }],
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: 'Retornos',
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: value => `$${value / 1000}k`,
            },
            gridLines: {
              display: false,
            },
          }],
          xAxes: [{
            barPercentage: 0.8,
            gridLines: {
              display: false,
            },
          }],
        },
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.project {
  width: 100%;
  height: min-content;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  cursor: pointer;
  border: 1px solid #e8e8e8;
  background-color: white;
  border-radius: 8px;
  padding: 16px 20px;
}
.project-header {
  width: 100%;
  display: flex;
  align-items: baseline;
  // border-bottom: 1px solid #e8e8e8;
  padding-bottom: 5px;
}
.project-name {
  font-size: 24px;
  font-weight: 600;
  margin-right: 10px;
}
.project-location {
  font-size: 18px;
}
.project-image {
  width: 100%;
  background-image: url("/header2.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100px;
  border-radius: 4px;
}
.project-link {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 12px 0;
  margin-top: 20px;
  color: #3479e9;
  border-radius: 100px;

  & + .project-link {
    margin-top: 0;
  }
}
.investment-info {
  display: flex;
  width: 100%;
}
.project-info {
  padding: 0 0 0 16px;
  margin: 16px 0;
  border-left: 1px solid #e8e8e8;
  width: 35%;
  display: flex;
  flex-direction: column;
}
.project-stats {
  width: 65%;
  margin: 16px 0;
  display: flex;
  flex-wrap: wrap;
}
.stat {
  width: 50%;

  & + .stat {
    margin-top: 12px;
  }
}
.stat-value {
  font-size: 24px;
}
.stat-name {
  font-size: 16px;
  color: #5f6368;
  margin-bottom: 6px;
}
.project-title {
  font-size: 18px;
  font-weight: bolder;
  font-family: 'Roboto Condensed', sans-serif;
}
.project-details {
  width: 100%;
  // border-top: 1px solid #e8e8e8;
}
.p-pay {
  display: flex;
  width: 100%;
  font-size: 15px;
  justify-content: space-between;
  padding: 12px 0;

  & + .p-pay {
    border-top: 1px solid #e8e8e8;
  }
}
.project-payments {
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 260px;
  overflow-y: scroll;
  align-items: flex-start;
  align-content: flex-start;
}
.project-graph {
  width: 100%;
  margin: 10px 0;
}
.payments-header {
  width: 100%;
  margin: 12px 0;
  font-size: 20px;
}
.details-button {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 14px 0 0 0;
  color: #3479e9;
}
.empty-state {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.project-link-m {
  display: none;
  width: 100%;
  justify-content: center;
  padding: 12px 0;
  margin-top: 20px;
  color: #3479e9;
  border-radius: 100px;
}
@media only screen and (max-width: 550px) {
  .project-info {
    display: none;
  }
  .project-stats {
    width: 100%;
  }
  .project-link-m {
    display: flex;
  }
}
@media only screen and (max-width: 390px) {
  .project-header {
    flex-direction: column;
  }
  .project-location {
    margin-top: 6px;
  }
  .project-info {
    display: none;
  }
  .stat {
    width: 100%;
  }
  .project-stats {
    width: 100%;
    flex-direction: column;
  }
}
</style>
